import { c as _c } from "react/compiler-runtime";
import { MailingId } from 'modules/mailing/types/mailing-interface';
import React from 'react';
import EditorBlock from 'shared/components/dashboard-mail-editor/components/editor-block';
import { useMailingState } from 'shared/components/dashboard-mail-editor/hooks/use-mailing-state';
import { useUnsavedEmail } from 'shared/components/dashboard-mail-editor/hooks/use-unsaved-email';
import { twJoin } from 'tailwind-merge';
interface SplitTestEditorBlockProps {
  variantA: ReturnType<typeof useMailingState>;
  variantB: ReturnType<typeof useMailingState>;
  unsavedDataVariantA: ReturnType<typeof useUnsavedEmail>;
  unsavedDataVariantB: ReturnType<typeof useUnsavedEmail>;
  isLoading: boolean;
  disabled: boolean;
  selectedVariantId: MailingId;
}
export function SplitTestEditorBlock(t0) {
  const $ = _c(11);
  const {
    selectedVariantId,
    variantA,
    variantB,
    unsavedDataVariantB,
    unsavedDataVariantA,
    isLoading,
    disabled
  } = t0;
  const isVariantASelected = selectedVariantId === variantA.mailing.id;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = twJoin("rounded-tl-none");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isVariantASelected ? variantA.tempState : variantB.tempState;
  const t3 = isVariantASelected ? variantA.onChangeEmail : variantB.onChangeEmail;
  const t4 = isVariantASelected ? variantA.errors : variantB.errors;
  const t5 = isVariantASelected ? variantA.mailing.id : variantB.mailing.id;
  let t6;
  if ($[1] !== disabled || $[2] !== isLoading || $[3] !== t2 || $[4] !== t3 || $[5] !== t4 || $[6] !== t5) {
    t6 = <EditorBlock className={t1} isSwitchEditorButtonShown={true} isPreFetching={isLoading} disabled={disabled} tempState={t2} onChangeEmail={t3} errors={t4} mailingId={t5} />;
    $[1] = disabled;
    $[2] = isLoading;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = isVariantASelected ? unsavedDataVariantA.UnsavedEmailConfirmationModal : unsavedDataVariantB.UnsavedEmailConfirmationModal;
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
}